import { NgModule } from '@angular/core';
import { EqualValidator } from './equal-validator/equal-validator';
@NgModule({
	declarations: [EqualValidator],
	imports: [],
	exports: [EqualValidator]
})
export class DirectivesModule {}



// WEBPACK FOOTER //
// ./src/directives/directives.module.ts